import { translate } from '@lucidlink/uicore';
export const setHandle = ({ heading }) => {
    return {
        heading,
    };
};
export const getHeading = () => {
    return {
        account: translate('My account'),
        'account-login-required': translate('Login with password required'),
        billing: translate('Billing and invoices'),
        'billing-checkout': translate('Checkout'),
        'billing-plans': translate('Choose plan'),
        'partner-organization-migrate': translate('Upgrade from Classic'),
        'configure-permissions': translate('Configure permissions'),
        'developer-tools': translate('Developer Tools'),
        'domain-management': translate('Domain management'),
        'edit-permissions': translate('Edit permissions'),
        error: translate('Error'),
        'filespace-create': translate('Create filespace'),
        'filespace-migration': translate('Upgrade filespace'),
        'filespace-dashboard': translate('Filespace dashboard'),
        'filespace-files': translate('File browser'),
        'filespace-settings': translate('Filespace settings'),
        'filespace-upgrade': translate('Upgrade filespace'),
        'guest-links': translate('Guest links'),
        'guest-browser': translate('Guest access'),
        guests: translate('Guests'),
        'lucidlink-connect': translate('LucidLink Connect'),
        'group-details': translate('Groups'),
        groups: translate('Groups'),
        'member-details': translate('Members'),
        members: translate('Members'),
        'no-workspaces': translate('Create workspace'),
        'partner-client': translate('Management Platform'),
        'partner-clients': translate('Management Platform'),
        'partner-create-contract': translate('Management Platform'),
        'partner-preview-contract': translate('Management Platform'),
        'partner-api-key': translate('Management Platform'),
        'partner-dashboard': translate('Management Platform'),
        'partner-details': translate('Management Platform'),
        'partner-prepare-upgrade': translate('Management Platform'),
        'partner-setup-filespace-upgrade': translate('Management Platform'),
        'partner-view-filespace-upgrade': translate('Management Platform'),
        'partner-migrate-contract': translate('Management Platform'),
        permissions: translate('Access and permissions'),
        'pinned-files': translate('Pinned files'),
        'service-accounts': translate('Service accounts'),
        snapshots: translate('Snapshots'),
        'sso-landing': translate('SSO landing'),
        'sso-login': translate('SSO login'),
        'sso-settings': translate('SSO settings'),
        'two-factor-authentication': translate('Two-factor authentication'),
        'workspace-create': translate('Create workspace'),
        'workspace-dashboard': translate('Workspace dashboard'),
        'workspace-lock': translate('Workspace locked'),
        'workspace-permissions': translate('Access and permissions'),
        'workspace-settings': translate('Workspace settings'),
        'workspace-suspended': translate('Workspace suspended'),
        'partner-upsell': translate('Upsell'),
    };
};
